import { render, staticRenderFns } from "./SiteNavMobileV2AboutNav.vue?vue&type=template&id=3aae5138&scoped=true&lang=pug"
import script from "./SiteNavMobileV2AboutNav.vue?vue&type=script&lang=js"
export * from "./SiteNavMobileV2AboutNav.vue?vue&type=script&lang=js"
import style0 from "./SiteNavMobileV2AboutNav.vue?vue&type=style&index=0&id=3aae5138&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae5138",
  null
  
)

export default component.exports